import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useCreateFabState } from '@/contexts/CreateFabContext';
import { cn } from '@/services/utils';

const showThreshold = 480;

export function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  const fabState = useCreateFabState();

  useEffect(() => {
    let ticking = false;

    const updateVisibility = () => {
      ticking = false;
      setVisible(window.scrollY > showThreshold);
    };

    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateVisibility);
    };

    updateVisibility();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ left: 0, top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  return (
    // Sits just above the collapsed create button and steps up by one row
    // (the fab's expanded actions) once those actions are revealed. Below md it also clears the
    // fixed MobileTabBar (h-16).
    <div
      className={cn(
        'fixed right-4 z-30 bottom-[calc(9.75rem+env(safe-area-inset-bottom))] transition-transform duration-200 sm:right-6 md:bottom-[calc(5.75rem+env(safe-area-inset-bottom))]',
        fabState !== 'collapsed' && '-translate-y-[3.75rem]'
      )}
    >
      <Button
        type="button"
        size="icon-lg"
        aria-label="Scroll to top"
        aria-hidden={!visible}
        tabIndex={visible ? 0 : -1}
        onClick={handleClick}
        className={cn(
          'size-11 rounded-full border border-white bg-white text-slate-600 shadow-[0_10px_30px_rgba(15,23,42,0.14)] transition duration-200 hover:bg-slate-50 hover:text-slate-900',
          visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'
        )}
      >
        <ArrowUp className="size-5" />
      </Button>
    </div>
  );
}
